import { apiGet, apiSend } from './http';

// GET /api/user — current user properties (id, email, balance, decoders, ...).
export const getUser = () => apiGet('/api/user');

// GET /api/user/regions — list of available regions.
export const getRegions = () => apiGet('/api/user/regions');

// POST /api/user — update current user properties.
export async function updateUser(data) {
  const response = await apiSend('/api/user', 'POST', data);
  if (!response.ok) throw new Error('Network response was not ok');
}
